import $ from 'jquery'

$('#tag_machin_learn').click();
$('#tag_gdpr').click();


// WEBPACK FOOTER //
// ./src/mixins/default_words.js